import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconHairdressingSalon: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.5 8c-1.8 0-3.3 1.4-3.5 3.3l-4 1.2.8-3.5h.2c1.9 0 3.5-1.6 3.5-3.5S13.9 2 12 2 8.5 3.6 8.5 5.5c0 1.1.6 2.1 1.4 2.8l-1.1 4.9L2.7 15c-.5.2-.8.7-.7 1.2.2.5.6.8 1 .8h.3l5-1.5L7 20.8c-.1.5.2 1.1.8 1.2H8c.5 0 .9-.3 1-.8l1.5-6.5 5-1.5c.6 1.1 1.7 1.8 3 1.8 1.9 0 3.5-1.6 3.5-3.5S20.4 8 18.5 8zM12 4c.8 0 1.5.7 1.5 1.5S12.8 7 12 7s-1.5-.7-1.5-1.5S11.2 4 12 4zm6.5 9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z',
    })
  )
}
